import { applyMiddleware, compose } from 'redux';
import { createApi } from '../api';
import { ContentPlanRootState } from '../elements/contentPlan/store';
import { getToken } from './authClient';

const getAPI = () => createApi({ getToken });

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const enhancers = composeEnhancers(
  applyMiddleware<any, ContentPlanRootState>(
    ({ dispatch, getState }) =>
      next =>
      action => {
        const elFn = getState().app?.elFn;
        if (typeof action === 'function') {
          return action(dispatch, getState, {
            getToken,
            getAPI: elFn?.getAPI || getAPI
          });
        }
        return next(action);
      }
  )
);

const getSelections = (s: ContentPlanRootState) => ({
  w: s.planning?.selectedWorkspace?.props?.refId,
  params: {
    v: s.view?.selected?.props?.refId,
    id: s.form?.data?.props?.refId
  }
});
